import { MEETINGMANAGEMENT_URL } from "utils/constants";
import { ENDPOINTSMEETINGSMANAGEMENT } from "utils/endpoints";
import { http } from "utils/http";

export const putAccept = ( (data) =>  http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.accept ,
    method: 'put',
    data: data
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const getAccept = ( (jobId) =>  http({
    baseURL:MEETINGMANAGEMENT_URL,
    url: ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.Invitation ,
    method: 'get',
    params: {
        jobId
    }
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)